import { getBackendBaseUrl } from './apiUtils';
import 'whatwg-fetch';

export const refreshedJWTApi = async (jwt: string) => {
  const telehealthBaseURL = getBackendBaseUrl();

  const data = await fetch(`${telehealthBaseURL}/refresh`, {
    method: 'POST',
    headers: new Headers({
      Authorization: `Bearer ${jwt}`,
    }),
  });

  if (data.status !== 200) {
    throw new Error('Failed API fetchRefreshedJWT');
  }
  // Since the response doesn't follow the same data.json().response pattern as many apis, we aren't using callEndpoint from apiUtils
  const response = (await data.json()) as RefreshJWTResponse;
  if (!response.jwt || response.jwt.length < 1) {
    throw new Error('Failed API fetchRefreshedJWT, missing jwt -- ' + JSON.stringify(response));
  }
  return response;
};
